// extracted by mini-css-extract-plugin
module.exports = {"component":"pickup-point-select-multiple_component__s19DG","content":"pickup-point-select-multiple_content__xcIRh","headline":"pickup-point-select-multiple_headline__swESM"};